import { createFileRoute, useNavigate } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/_layout/inventory/inspections")({
  component: InspectionsPage,
});

import { useState } from "react";
import { SidebarInset } from "@/components/ui/sidebar";
import { DashboardHeader } from "@/components/dashboard-header";
import PageHeader from "@/components/reusable-components/header/page-header";
import { PaginationComponent } from "@/components/crud/Pagination/Pagination";
import { PAGE_SIZE_OPTIONS } from "@/lib/constants";
import { usePaginationState } from "@/hooks/ui/usePaginationState";
import { useFetchAllInspections } from "@/hooks/api/inventory/useCollectionsLabels";
import { InspectionTable } from "@/components/inventory/tables/InspectionTable";
import { InspectionDetailSheet } from "@/components/inventory/InspectionDetailSheet";
import type { InspectionRecord } from "@/types/inventory";

function InspectionsPage() {
  const navigate = useNavigate();
  const { page, setPage, pageSize, handlePageSizeChange } =
    usePaginationState();

  const inspectionsQuery = useFetchAllInspections({
    page_size: pageSize,
    page,
  });
  const inspections = inspectionsQuery.data?.results ?? [];
  const count = inspectionsQuery.data?.count ?? 0;
  const isLoading = inspectionsQuery.isPending;
  const isFetching = inspectionsQuery.isFetching;

  const [selectedRecord, setSelectedRecord] = useState<InspectionRecord | null>(
    null
  );

  return (
    <SidebarInset>
      <DashboardHeader />
      <div className="space-y-4 p-6 pt-0">
        <PageHeader
          title="Inspection Records"
          description="View all inspection history across all items"
          isLoading={isFetching}
        />

        <InspectionTable
          inspections={inspections}
          isLoading={isLoading}
          onView={(r) => setSelectedRecord(r)}
          onRowClick={(r) =>
            navigate({
              to: "/admin/inventory/inspections/$id",
              params: { id: String(r.id) },
            })
          }
        />

        <PaginationComponent
          count={count}
          page={page}
          onPageChange={setPage}
          isLoading={isFetching}
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
          pageSizeOptions={PAGE_SIZE_OPTIONS}
        />

        <InspectionDetailSheet
          record={selectedRecord}
          onOpenChange={(open) => {
            if (!open) setSelectedRecord(null);
          }}
        />
      </div>
    </SidebarInset>
  );
}
